
import {defineComponent} from "vue"
import {useRouter} from "vue-router";

export default defineComponent({
  data() {
    return {
      router: useRouter(),
    }
  },
  methods: {}
})

